import vendorService from "../../../../services/procurementService/vendorService";
import { useQuery } from "@tanstack/react-query";
import { VendorInterface } from "../../../../models/ProcurementModule/Vendor";
import { CACHE_KEY_VENDORS } from "../../../../utils/constants";

const useVendors = (page: number, pageSize: number) =>
  useQuery<VendorInterface[], Error>({
    queryKey: [CACHE_KEY_VENDORS, page, pageSize],
    queryFn: () => vendorService.GetAll(page, pageSize),
    initialData: [],
  });

export default useVendors;
